module.exports = __webpack_public_path__ + "static/img/arduino_nano-3.7fda3c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/arduino_nano-3.svg
// module id = g2ki
// module chunks = 0